import domaineFormation from "./domaineFormation"
export default domaineFormation;
